export default () =>
  new Promise((resolve, reject) => {
    window.axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}chat/room`, {
        headers: {
          ignoreLoading: true,
        },
      })
      .then(({ data }) => {
        let rooms = {};
        if (data) {
          rooms = data.rooms;
        }
        resolve(rooms);
      })
      .catch((error) => {
        reject(error);
      });
  });
